import React, { useCallback, useEffect, useState } from "react";
import { Column, Pager, Paging } from "devextreme-react/data-grid";
import { LVGridCarga } from "../../../Basicos/LVGridCarga";

function LV_ART_Articulos_SelectorConGrid_Grid({ dataSource,
  tienePresentaciones = false, tieneTamanos = false, tieneUnidadesMedida = false,
  actualizarGrilla, muestraComponentesDelTotal = true, onTotalImporteDelComponenteChange, CodigoTipoDoc, pageSize = 4 }) {

  const [gridDataSource, setGridDataSource] = useState(dataSource);
  const [totales, setTotales] = useState("Totales - Neto: $0 - Descuentos.: $0 - Recargos: $0 - I.V.A.: $0 - Imp. Int.: $0 - TOTAL: $0");

  const forzarActualizacionGrillaLocal = () => {
    dataSource.forEach(row => {
      handleOnRowUpdatedLocal({ data: row });
    });
  }

  const customizeTotal = useCallback((e) => {
    if (e.value) {
      const formattedValue = e.value.toFixed(1);
      onTotalImporteDelComponenteChange(e.value);
      return `T: ${formattedValue}`;
    }
  }, []);

  const handleOnRowUpdatedLocal = async (e) => {
    const updatedRow = e.data;
    let PorcentajeIVA = updatedRow.PorcentajeIVA
    if (!PorcentajeIVA) {
      PorcentajeIVA = 21
    }
    const tiposDocSinIVA = [41, 42, 43, 71, 72, 73];
    if (tiposDocSinIVA.includes(CodigoTipoDoc)) {
      PorcentajeIVA = 0
    }

    let PorcentajeImpuestosInternos = updatedRow.PorcentajeImpuestosInternos
    if (!PorcentajeImpuestosInternos) {
      PorcentajeImpuestosInternos = 0
    }
    
    const ImporteNeto = updatedRow.ImporteNeto
    const ImporteSubTotal = updatedRow.ImporteNeto - updatedRow.ImporteBonificaciones + updatedRow.ImporteRecargos
    const ImporteIVA = ImporteSubTotal / 100 * PorcentajeIVA    
    const ImporteImpuestosInternos = ImporteSubTotal / 100 * PorcentajeImpuestosInternos
    const importeTotal = ImporteSubTotal + ImporteIVA + ImporteImpuestosInternos;

    // Actualiza el valor de los unitarios
    updatedRow.ImporteIVA = ImporteIVA;
    updatedRow.ImporteImpuestosInternos = ImporteImpuestosInternos;
    updatedRow.ImporteSubTotal = ImporteSubTotal;
    updatedRow.ImporteTotal = importeTotal;

    // Actualiza el valor de los totales (x Cantidad)
    updatedRow.ImporteNetoTotal = ImporteNeto * updatedRow.Cantidad;
    updatedRow.ImporteBonificacionesTotal = updatedRow.ImporteBonificaciones * updatedRow.Cantidad;
    updatedRow.ImporteDescuentos = updatedRow.ImporteBonificaciones;
    updatedRow.ImporteDescuentosTotal = updatedRow.ImporteBonificaciones * updatedRow.Cantidad;
    updatedRow.ImporteRecargosTotal = updatedRow.ImporteRecargos * updatedRow.Cantidad;
    updatedRow.ImporteIVATotal = ImporteIVA * updatedRow.Cantidad;
    updatedRow.ImporteImpuestosInternosTotal = ImporteImpuestosInternos * updatedRow.Cantidad;

    const importeSubTotalTotal = updatedRow.ImporteNetoTotal - updatedRow.ImporteBonificacionesTotal + updatedRow.ImporteRecargosTotal;
    updatedRow.ImporteSubTotalTotal = importeSubTotalTotal;

    const importeTotalTotal = updatedRow.ImporteNetoTotal - updatedRow.ImporteBonificacionesTotal + updatedRow.ImporteRecargosTotal + updatedRow.ImporteIVATotal + updatedRow.ImporteImpuestosInternosTotal;
    updatedRow.ImporteTotalTotal = importeTotalTotal;

    // Actualiza el estado del dataSource
    const updatedDataSource = [...gridDataSource];
    const rowIndex = updatedDataSource.findIndex(row => row.id === updatedRow.id);    
    if (rowIndex !== -1) {
      updatedDataSource[rowIndex] = updatedRow;
      setGridDataSource(updatedDataSource);
    }

    let totalNeto = 0;
    let totalBonificaciones = 0;
    let totalRecargos = 0;
    let totalIVA = 0;
    let totalImpInt = 0;
    let totalGeneral = 0;

    dataSource.forEach(row => {
      totalNeto += row.ImporteNetoTotal || 0;
      totalBonificaciones += (row.ImporteBonificaciones * row.Cantidad) || 0;
      totalRecargos += (row.ImporteRecargos * row.Cantidad) || 0;
      totalIVA += row.ImporteIVATotal || 0;
      totalImpInt += row.ImporteImpuestosInternosTotal || 0;
      totalGeneral += row.ImporteTotalTotal || 0;
    });

    onTotalImporteDelComponenteChange(totalGeneral.toFixed(0), totalNeto.toFixed(2));

    setTotales(`Totales - Neto: $${totalNeto.toFixed(0)} - 
    Descuentos.: $${totalBonificaciones.toFixed(0)} - 
    Recargos: $${totalRecargos.toFixed(0)} - 
    I.V.A.: $${totalIVA.toFixed(0)} - 
    Imp. Int.: $${totalImpInt.toFixed(0)} - 
    TOTAL: $${totalGeneral.toFixed(0)}`);
  };

  useEffect(() => {
    if (actualizarGrilla) {
      forzarActualizacionGrillaLocal();
    }
  }, [actualizarGrilla, dataSource]);

  useEffect(() => {
    forzarActualizacionGrillaLocal();
  }, [CodigoTipoDoc]);

  return (
    <div className="LV-GroupBox-div" style={{ textAlign: 'right' }}>
      <LVGridCarga
        dataSource={dataSource}
        id="gridContainer"
        keyExpr="id"
        AnchoBotonera="38"
        allowEditing={true}
        onRowUpdated={handleOnRowUpdatedLocal}
        onRowRemoved={handleOnRowUpdatedLocal}
      >
        <Column caption="Orden" dataField="id" width="70" alignment="Right" dataType="number" />
        <Column caption="Cantidad" dataField="Cantidad" width="80" alignment="Left" dataType="string" />

        <Column caption="Artículo" alignment="Center">
          <Column caption="Código" dataField="CodigoArticulo" width="80" alignment="Left" dataType="string" allowEditing={false} />
          <Column caption="Descripción" dataField="Articulo" width="100%" minWidth="200" alignment="Left" dataType="string" allowEditing={false} />
          <Column caption="Presentación" dataField="Presentacion" width="80" alignment="Left" dataType="string" visible={tienePresentaciones} allowEditing={false} />
          <Column caption="Tamaño" dataField="Tamano" width="80" alignment="Left" dataType="string" visible={tieneTamanos} allowEditing={false} />
          <Column caption="Unidad Medida" dataField="UnidadMedida" width="80" alignment="Left" dataType="string" visible={tieneUnidadesMedida} allowEditing={false} />
        </Column>
        <Column caption="Importes" alignment="Center">
          <Column caption="Neto" dataField="ImporteNeto" width="180" alignment="Right" dataType="number" format="currency" visible={muestraComponentesDelTotal} />
          <Column caption="Descuentos" dataField="ImporteBonificaciones" width="180" alignment="Right" dataType="number" format="currency" visible={muestraComponentesDelTotal} />
          <Column caption="Recargos" dataField="ImporteRecargos" width="180" alignment="Right" dataType="number" format="currency" visible={muestraComponentesDelTotal} />
          <Column caption="I.V.A." dataField="ImporteIVA" width="180" alignment="Right" dataType="number" format="currency" visible={muestraComponentesDelTotal} />
          <Column caption="Imp.Internos" dataField="ImporteImpuestosInternos" width="180" alignment="Right" dataType="number" format="currency" visible={muestraComponentesDelTotal} />
          <Column caption="SubTotal" dataField="ImporteTotal" width="100" alignment="Right" dataType="number" format="currency" allowEditing={false} visible={muestraComponentesDelTotal} />
          <Column caption="Total" dataField="ImporteTotalTotal" width="150" alignment="Right" dataType="number" format="currency" allowEditing={false} />
        </Column>

        <Column caption="Importes" alignment="Center" visible={false}>
          <Column caption="Neto" dataField="ImporteNetoTotal" width="100" alignment="Right" dataType="number" format="currency" />
          <Column caption="Descuentos" dataField="ImporteBonificacionesTotal" width="100" alignment="Right" dataType="number" format="currency" />
          <Column caption="Recargos" dataField="ImporteRecargosTotal" width="100" alignment="Right" dataType="number" format="currency" />
          <Column caption="I.V.A." dataField="ImporteIVATotal" width="100" alignment="Right" dataType="number" format="currency" />
          <Column caption="Imp.Internos" dataField="ImporteImpuestosInternosTotal" width="100" alignment="Right" dataType="number" format="currency" />
        </Column>
        <Column caption="Porcentajes" alignment="Center" visible={false}>
          <Column caption="IVA" dataField="PorcentajeIVA" width="100" alignment="Right" dataType="number" />
          <Column caption="Impuestos Internos" dataField="PorcentajeImpuestosInternos" width="100" alignment="Right" dataType="number" />
        </Column>

        <Paging defaultPageSize={pageSize} />
        <Pager
          showPageSizeSelector={false}
        />
      </LVGridCarga>

      {totales}
    </div>
  );
}

export default LV_ART_Articulos_SelectorConGrid_Grid